// TODO: Currently only used in user-account-app and requires React Router v6.
// Can be moved to shared-hooks once it supports React Router v6.
import { useNavigate } from "react-router-dom";
import _isFunction from "lodash/isFunction";
import _some from "lodash/some";

type Permissions = (boolean | (() => boolean))[];

export default function usePagePermission(
  permissions: Permissions,
  redirect: string
) {
  const navigate = useNavigate();
  const hasPermission = _some(permissions, (permission) => {
    return _isFunction(permission) ? permission() : permission;
  });

  if (!hasPermission) navigate(redirect, { replace: true });
}
